import './styles/Department.css';

const organizations = [
  { id: '01', name: 'Committees', icon: '🏢' },
  { id: '02', name: 'Organization 02', icon: '🏛️' },
  { id: '03', name: 'Organization 03', icon: '🏦' },
  { id: '04', name: 'Organization 04', icon: '🏭' },
  { id: '05', name: 'Organization 05', icon: '🏪' },
  { id: '06', name: 'Organization 06', icon: '🏬' },
];

const OrganizationTabs = () => {
  return (
    <div className="organization-tabs">
      {organizations.map((org, index) => (
        <button key={org.id} className={`organization-tab ${index === 0 ? 'active' : ''}`}>
          <span className="organization-icon">{org.icon}</span>

          <span className="organization-name">{org.name}</span>
        </button>
      ))}
    </div>
  );
};

export default OrganizationTabs;
